// extracted by mini-css-extract-plugin
export default {"dropdownLink":"NavbarConstants_dropdownLink__rZ44B"};